import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { List } from 'appkit-react';
import { ProjectCard as ListItem } from '@components';
// import '@style/modules/project/projectList.scss';
import '../../../../styles/modules/project/projectList.scss';
import action from '@flux/action';
import { API } from '@service';
import { setSessionStorage } from '@utils/windowUtil';
import { isEmailVerifiedOrBypassed } from '@utils/emailVerificationBypass';

function ProjectsListView({ data, matchBreadCrumb, deleteProject, userInfo }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const emailVerModalRef = useSelector(
    (state) => state.common.emailVerModalRef,
  );

  const saveProjectInfo = (id, name) => {
    setSessionStorage('projectName', name);
    setSessionStorage('currentId', id);
    // matchBreadCrumb(name);
  };

  const handleClick = async (project = {}) => {
    const { projectId, projectName } = project;
    if (!projectId) {
      return;
    }
    dispatch(action.changeLoading(true));
    try {
      const result = await API.getProjectCompaniesInfoRequest(projectId);
      if (result?.theme) {
        dispatch(action.changeTheme(result.theme));
        saveProjectInfo(projectId, projectName);
      }
      history.push(`/project-detail/${projectId}`);
    } finally {
      dispatch(action.changeLoading(false));
    }
  };
  const handleDelete = (projectId) => {
    dispatch(action.deleteProjectFromList(projectId));
  };

  const handlePin = (projectId) => {
    dispatch(action.changeProjectPinStatus(projectId));
  };
  const handleSetting = (e) => {
    if (e.currentId) {
      saveProjectInfo(e.currentId, e.projectName);
      Promise.all([
        dispatch(action.changePermissionLoading(true)),
        dispatch(action.getCustomizedModules(e.currentId)),
        dispatch(action.getAccessibleModules(e.currentId)),
        dispatch(action.getProjectInfo(e.currentId)),
      ])
        .then(() => {
          history.push(`/projects/setting?projectId=${e.currentId}`);
        })
        .finally(() => {
          dispatch(action.changePermissionLoading(false));
        });
    }
  };

  const click = (e) => {
    if (e.currentId) {
      if (isEmailVerifiedOrBypassed(userInfo)) {
        handleSetting(e);
      } else {
        emailVerModalRef &&
          emailVerModalRef.show &&
          emailVerModalRef.show({
            callback: () => {
              handleSetting(e);
              dispatch(action.getUserInfo);
            },
          });
      }
    }
  };

  return (
    <List className="project-list-wrapper">
      {data.map((item) => (
        <ListItem
          onClick={handleClick}
          key={`project-list-${item.projectId}`}
          data={item}
          settingClick={click}
          onDelete={handleDelete}
          onPin={handlePin}
        />
      ))}
    </List>
  );
}

export default memo(ProjectsListView);
